export default __webpack_public_path__ + "static/media/RBM.c5eccfc7.svg";